"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeOptins_de_de = void 0;
function backofficeOptins_de_de() {
    return {
        "backoffice.optins.title": "Einverständniserklärungen",
        "backoffice.optins.subtitle": "Verwalten Sie Formulare für Einverständniserklärungen Ihrer Kunden.",
        "backoffice.optins.create": "Einverständniserklärungen erstellen",
        "backoffice.optins.creationtitle": "Neue Einverständniserklärung erstellen",
        "backoffice.optins.empty": "Keine Einverständniserklärungen gefunden",
        "backoffice.optins.nodescription": "Kein Beschreibungstext erfasst",
        "backoffice.optins.description": "Einverständniserklärungen ermöglichen es Ihnen, Zustimmungen von Ihren Kunden einzuholen. Klassische Beispiele hierfür sind: Newsletter Anmeldung, Datenschutzerklärungen oder Allgemeine Geschäftsbedingungen."
    };
}
exports.backofficeOptins_de_de = backofficeOptins_de_de;
